import React, { useState, useEffect } from 'react';
import { IonContent, IonPage, IonButton } from '@ionic/react';
import DatePicker  from '../components/DatePicker';
import Header from 'src/components/HeaderGenerico';
import { makeStyles, Paper, Box } from '@material-ui/core';
import Select from 'react-select';
import Operarios from 'src/services/operarios';
import OperariosRemplazos from 'src/services/operarioRemplazo';
import { MarcacionTabla } from 'src/components/DataTableMaterial';
import { closeOutline} from "ionicons/icons";
import { useHistory } from 'react-router';
import Gestion from 'src/services/gestionMarcacion';

const useStyles = makeStyles({
  card: {
    maxWidth: 320,
    marginTop: 15,
    marginBottom: 15,
    marginLeft: 'auto',
    marginRight: 'auto',
    boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
    padding: 15,
    borderRadius: 5,
  },
  box: {
    display: 'flex',
    flexFlow: 'column wrap',
    gridGap: '2px',
    alignItems: 'center',
    justifyContent: 'center',
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 15,
    marginBottom: 15,
      },
});

const selectStyles = {
  control: (provided) => ({
    ...provided,
    boxShadow: 'none', // Eliminar la sombra del control
    borderColor: '#FFF', // Color del borde
    color: '#000',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#000C' : '0CC',
    ':hover': {
      backgroundColor: '#000C',
      color: '#FFF',
      cursor: 'pointer',
    }
  }),
};

const Marcacion: React.FC = () => {
  const style = useStyles();
  const [fechaInicio, setFechaInicio] = React.useState<Date | undefined>(new Date());
  const [fechaFin, setFechaFin] = React.useState<Date | undefined>(new Date());
  const [puntoServicio, setPuntoServicio] = React.useState<{ value: string; label: string }[]>([]);
  const [nombrePuntoServicio, setNombrePuntoServicio] = useState<string>('');
  const [nombreOperario, setNombreOperario] = useState<string>('');
  const [opciones, setOpciones] = useState<{ value: string; label: string }[]>([]);
  const [marcacion, setMarcacion] = useState<any[]>([]);


  useEffect(() => {
    (async () => {
      await loadOperario();
      await loadPuntoServicio();
    })();
  }, []); // Cargar operarios al inicio


  const loadOperario = async () => {
    try {
      const response = await Operarios.listarOperarios();
      setOpciones(response.map((operario) => ({ value: `${operario.nombre} - ${operario.legajo}`, label: `${operario.nombre} - ${operario.legajo}`})));
    } catch (error) {
      console.error('Error loading operarios:', error);
    }
  };

  const loadPuntoServicio = async () => {
    try {
      const response = await OperariosRemplazos.listar();
  
      if (Array.isArray(response.data.datos)) {
        const puntosServicio = response.data.datos.map((element) => ({
          value: element.id,
          label: element.ps_nombre,
        }));
  
        setPuntoServicio(puntosServicio);
      }
    } catch (error) {
      console.error('Error loading puntos de servicio:', error);
    }
  }
  const traeMarcacion = async () => {
    const datos = {
      operario: nombreOperario,
      fechaInicio: fechaInicio?.toISOString().split('T')[0],
      fechaFin: fechaFin?.toISOString().split('T')[0],
      psID: nombrePuntoServicio,
    }
    console.log('Informacion para enviado', datos);
    try {
     await Gestion.traerMarcaciones(datos)
      .then(response => {
        console.log('Respuesta del back', response);
        if (response.data) {
          const datos = response.data;
          setMarcacion(datos);
          return datos;
        } else {
          console.log('No hay datos');
          return [];
        }
      })
    } catch (error) {
      console.error('Error loading puntos de servicio:', error);
    }
  }

  const handleMenuClose = (event) => {
    // event.action indica si se seleccionó una opción (select-option) o se cerró manualmente (menu-close)
    if (event.action === 'menu-close') {
      // Se ha cerrado manualmente, por lo tanto, la opción se eliminó
      // Puedes agregar lógica adicional aquí si es necesario
      handleChangePuntoServicio(null);
    }
  };

  const handleChangeOperario = (selectedOption) => {
    console.log(selectedOption)
    setNombreOperario(selectedOption ? selectedOption.value : null);
  };
  const handleChangePuntoServicio = (selectedOption) => {
    setNombrePuntoServicio(selectedOption ? selectedOption.value : null);
  };

  const navigate = useHistory()
  const HandleMarcacioinView = () => {
    navigate.goBack()
   }

  return (
    <IonPage>
      <Header titulo='' text={'ATRAS'} botonIzq={{ icono: closeOutline, action: HandleMarcacioinView}} />

      <IonContent id="marcaciones">
        <Paper className={style.card}>
         
          {/* fecha inicio */}
          <DatePicker 
          value={fechaInicio} 
          placeholder='Fecha Inicio'
          setValue={setFechaInicio} />


          {/* fecha fin */}
          <DatePicker 
          value={fechaFin}
          placeholder='Fecha Fin'
          setValue={setFechaFin}/>
          
          <Select
             value={puntoServicio.find((option) => option.label === nombrePuntoServicio)}
             onChange={handleChangePuntoServicio}
             onMenuClose={() => handleMenuClose(handleChangePuntoServicio)}
             isClearable={true}
            options={puntoServicio}
            placeholder="PUNTO DE SERVICIO"
            styles={selectStyles}
            maxMenuHeight={115}
            menuPlacement="top"
          />

          <Select
           value={opciones.find((option) => option.value === nombreOperario)}
           onChange={handleChangeOperario}
           isClearable={true}
            options={opciones}
            placeholder="BUSCAR OPERARIO"
            styles={selectStyles}
            maxMenuHeight={175}
            menuPlacement="top"
          />
          <IonButton onClick={traeMarcacion} color="primary">
            FILTRAR
          </IonButton>
        </Paper>

        
        <Box className={style.box}>
        <MarcacionTabla data={marcacion} onDeleteRow={() => console.log('')} />
      </Box>
      </IonContent>
    </IonPage>
  );
};

export default Marcacion;